let BAIXA_PRODUTIVA_SEM_MOVIMENTACAO = 10;
let BAIXA_PRODUTIVA_COM_MOVIMENTACAO = 11;
let BAIXA_IMPRODUTIVA = 12;
let GERAR_OS_REFAZER_DESOB = 13;

export {
  BAIXA_IMPRODUTIVA, BAIXA_PRODUTIVA_COM_MOVIMENTACAO, BAIXA_PRODUTIVA_SEM_MOVIMENTACAO, GERAR_OS_REFAZER_DESOB
};

